export enum LimitedProjectResource {
    TeamMap = "TeamMap",
    User = "User"
}